import { render } from "./WebcamVideo.vue?vue&type=template&id=357b6f62"
import script from "./WebcamVideo.vue?vue&type=script&lang=js"
export * from "./WebcamVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__